module.exports = __webpack_public_path__ + "static/media/EmptyImage.4192f515.svg";